import { Component, ReactNode } from 'react'

import { Box, Button, Typography } from '@mui/material'

type Props = {
  children: ReactNode
  onReset?: () => void
  resetLabel?: string
}

type State = {
  hasError: boolean
}

/**
 * Keeps the admin chrome visible and shows a recovery UI in the main pane
 * instead of letting a render error blank the whole window.
 */
export default class MainSectionErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Något gick fel när innehållet skulle visas.
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              this.setState({ hasError: false })
              this.props.onReset?.()
            }}
          >
            {this.props.resetLabel ?? 'Försök igen'}
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}
